import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritCustomerVehicleImagesQueryParamsType,
  GetCulpritCustomerVehicleImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerVehicleImages/getCulpritCustomerVehicleImagesQuery.type';

export const getCulpritCustomerVehicleImagesFunction = (
  params: GetCulpritCustomerVehicleImagesQueryParamsType,
): Promise<GetCulpritCustomerVehicleImagesQueryResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/images/customer/vehicle/`,
  );
};
